import {User} from '@models/user';
import {EventInterface} from '../interfaces/event.interface';
import {ConditionInterface} from '@interfaces/condition.interface';

export class Message {
  'id'?: number;
  'threadId'?: number;
  'toInThread'?: number;
  'body': string;
  'preview': string;
  'name'?: string;
  'mode'?: string;
  'subject'?: string;
  'from': User;
  'recipient': User;
  'recipients': number[];
  'to': User[];
  read_at: string;
  created_at: string;
  status: string;
  creating?: boolean;
  force?: boolean;
  system_message?: boolean;
  statusSystem?: number;
  events?: EventInterface[];
  default?: number;
  items_number?: number;
  condition?: ConditionInterface;
}
